import React from 'react';
import './gbi-tick-shield.scss';

/* eslint-disable max-len */
const GBITickSheild = () => (
  <svg className="gbi-tick-shield" viewBox="0 0 496.084 441.622">
    <path className="shield" d="M498,69.922a483.74,483.74,0,0,0-496.084,0C18.706,231,114.548,368.526,249.958,443.11,385.368,368.526,481.211,231,498,69.922Z" transform="translate(-1.916 -1.488)"/>
    <polygon className="tick" points="238.691 286.725 149.499 203.182 164.45 187.217 235.807 254.068 357.773 91.09 375.286 104.193 238.691 286.725"/>
  </svg>
);

export default GBITickSheild;
